import React from 'react';
import './Workflow Transaction List.css';
import ListTable from '../../Common Components/List_Table';
import NormalListTable from '../../Common Components/Normal_List_Table';

const WorflowTransactionList = ({onHandleClick,}) => {
    const transactionTableHeading = ["S.No", "Transaction Name","Workflow Name", "Job ID", "Client","Date","Create/Modified by",""];
 
  function createData(sNo,transactionName,workflowName,jobId,client,date,create,menu) {
    return { sNo,transactionName,workflowName,jobId,client,date,create,menu};
  }
  const transactionRows = [
    createData(1,"WF-TXN-CUDI-0215","WF-TMP-CUDI-DEV-0215","#JUN0256","CU Direct","09/18/2024","Marcel Leo",""),
    createData(2,"WF-TXN-CUDI-0215","WF-TMP-CUDI-DEV-0216","#JUN0247","CU Direct","09/18/2024","Marcel Leo",""),
    createData(3,"WF-TXN-CUDI-0215","WF-TMP-CUDI-DEV-0217","#JU874","CU Direct","09/18/2024","Marcel Leo",""),
    createData(4,"WF-TXN-CUDI-0215","WF-TMP-CUDI-DEV-0218","#APR0128","CU Direct","09/18/2024","Marcel Leo",""),
  ];
  return (
   <>
   <ListTable handleListClick={onHandleClick} template={false} task={false}/>
   <NormalListTable row={transactionRows} heading={transactionTableHeading} handleEditTransaction={onHandleClick} task={false} />
  </>
  )
}

export default WorflowTransactionList;